import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import PostUploadsBlock from "../../Posts/PostUploadsBlock/PostUploadsBlock";
import CollapsibleText from "../../CardPost/CollapsibleText";
import { setSender, setReceiver, setOrg, findOwner, fillProjectsData, fillProjectsDataContent } from '../../Helpers/Functions/TemplateVariables'

export default function PostList(props) {
  const [posts, setPosts] = useState(props.posts);
  const team = props.team

  const preview = props.preview || false;
  let uploadDisplayLimit = null;

  if (preview) {
    uploadDisplayLimit = 4;
  }
  const postItems = []
  for (const [index, post] of posts.entries()) {
    let updatedPost = {...post}
    let title = post.title

    updatedPost.safe_content = setOrg(post, team)
    updatedPost.title = updatedPost.title.replace(/{{organization.name}}/g, team.name)

  if (post.project_id == null) {
    let postOwner = post.user.user_info
    setSender(updatedPost, postOwner)
  }

  if (post.user_id == null) {
    fillProjectsData(updatedPost)
    updatedPost.safe_content = fillProjectsDataContent(updatedPost)
  }

    let content = updatedPost.safe_content;
    post.title = updatedPost.title

    if (preview) {
      content = <CollapsibleText content={content} />
    } else {
      content = <div dangerouslySetInnerHTML={{__html: content }} />
    }

    postItems.push(
      <div key={post.id} className="card card--post">
        <div className="card-header">
          <div className="card-title d-flex align-items-center justify-content-between">
            <div>
              {post.user_id !== null &&
              <div className="card--name-title">
              <a href='#'><strong>{post.user.visible_name}</strong></a> · <a href='#'>{post.title}</a>
              </div>}
              {post.user_id == null &&
              <div className="card--name-title">
              <a href='#'><strong>{post.project.name}</strong></a> · <a href='#'>{post.title}</a>
              </div>}
              <div className="card--post-time-ago">
                <span className="mr-1">
                  {post.created_at_in_words}
                </span>

                {post.ordered_uploads.length > 0 && (
                  <span className="badge badge-sm badge-primary badge-pill ml-1">
                    {post.ordered_uploads.length} Uploads
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div>
            {content}
          </div>

          <PostUploadsBlock uploads={post.ordered_uploads} limit={uploadDisplayLimit} />

          {post.user_id !== null &&
            <div className="w-100 text-right">
              <a href={post.url} className="card-link text-right">
                { post.comments.count ? post.comments.count : 0 } comments
              </a>
            </div>
          }
        </div>

        {preview && post.ordered_uploads && post.ordered_uploads.length > uploadDisplayLimit && (
          <div className="card-footer">
            <a href={post.url}>
              +{post.ordered_uploads.length - uploadDisplayLimit} more...
            </a>
          </div>)
        }
      </div>
    )
  }


  return (
    <React.Fragment>
      <div>
        {postItems}
      </div>
    </React.Fragment>
  );
}

PostList.propTypes = {
  posts: PropTypes.array
};
